import { useEffect, useState } from "react";
import { useWeb3React } from "@web3-react/core";
import { ALL_AIRDROP } from "../utils/constant/internalAddresses";

const useIsAirdropExisted = () => {
  const [isExisted, setIsExisted] = useState<boolean>(false);

  const { chainId } = useWeb3React();

  useEffect(() => {
    if (chainId && !!ALL_AIRDROP[chainId]) {
      setIsExisted(true);
    }
  }, [chainId]);

  return isExisted;
};

export default useIsAirdropExisted;
